import { StrictMode, useEffect, useRef } from 'react';

import { ErrorBoundary } from '@sentry/react';
import { APIProvider } from '@vis.gl/react-google-maps';

import { ErrorMessages } from './components/ErrorMessages';
import { DesktopPanel, MobilePanelTop, MobilePanelBottom } from './components/MapPanels/MapPanels';
import { ThemeProvider } from './components/theme-provider';
import { useSessionId } from './hooks/useSessionId';
import { getAirQuality } from './utils/cerc';

import { EmbeddedMap } from '@/components/EmbeddedMap/EmbeddedMap';
import { useConfigStore } from '@/store/ConfigStore';
import { useErrorStore } from '@/store/ErrorStore';

const SurveyBanner = () => {
  return (
    <div className="flex gap-2 bg-[#FFD420] px-6 py-2 lg:w-sm dark:bg-[#FFD420]/50">
      <div className="font-medium">
        <a target="_blank" href="https://s.userzoom.com/m/MSBDMTg0NVM3NSAg" className="underline underline-offset-2">
          Have your say on our new air quality tools
        </a>
      </div>
    </div>
  );
};

function App() {
  const config = useConfigStore((state) => state.config);
  const globalError = useErrorStore((state) => state.globalError);

  const defaultCenter = config?.bounds
    ? {
        lat: (config.bounds.southwest[0] + config.bounds.northeast[0]) / 2,
        lng: (config.bounds.southwest[1] + config.bounds.northeast[1]) / 2,
      }
    : undefined;

  const warm = useRef(false);
  useSessionId();

  // prewarm the air quality function
  useEffect(() => {
    if (warm.current) {
      return;
    }
    void getAirQuality(new Date(), []);
    warm.current = true;
  }, []);

  return (
    <StrictMode>
      <ErrorBoundary>
        <ThemeProvider>
          <APIProvider apiKey={String(import.meta.env.VITE_GOOGLE_MAPS_API_KEY)}>
            <ErrorMessages />
            {!globalError && (
              <div
                className="lt-lg:flex-col fixed flex h-screen w-screen overflow-y-auto print:flex-row"
                style={{ height: '100dvh' }}
              >
                <div>
                  <SurveyBanner />
                  <DesktopPanel />
                  <MobilePanelTop />
                </div>
                <EmbeddedMap className="h-full w-full" defaultCenter={defaultCenter} />
                <MobilePanelBottom />
              </div>
            )}
          </APIProvider>
        </ThemeProvider>
      </ErrorBoundary>
    </StrictMode>
  );
}

export default App;
